import { render, staticRenderFns } from "@/components/CallController/components/CallNotification/CallNotification.pug?vue&type=template&id=ec315966&scoped=true&lang=pug&"
import script from "./CallNotification.vue?vue&type=script&lang=ts&"
export * from "./CallNotification.vue?vue&type=script&lang=ts&"
import style0 from "@/components/CallController/components/CallNotification/CallNotification.scss?vue&type=style&index=0&id=ec315966&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec315966",
  null
  
)

export default component.exports